// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://use.typekit.net/laj1zvb.css);"]);
// Module
exports.push([module.id, ".hrsata-jobs #app-wrapper{background:#f5f6fa}.hrsata-jobs .loading-overlay{background:#fff;position:fixed;top:0;left:0;right:0;bottom:0;z-index:99999}.hrsata-jobs .title-2{font-family:forma-djr-display,sans-serif;font-weight:700}@media only screen and (min-width:960px){.hrsata-jobs .title-2{font-size:2rem;line-height:2.6rem}}.hrsata-jobs .v-application--wrap{min-height:auto!important;padding-top:10px;padding-bottom:25px}", ""]);
// Exports
module.exports = exports;
